import { Injectable } from '@angular/core';
 
@Injectable()
export class CustomerCarts {
 
  public message: any = "I'm new here";
  public customerCarts = [];

  constructor() {
 
  }
 
  setMessage(message) {
    this.message = message;
  }
  setCustomerCarts(carts){
    console.log("setCustomerCarts ----- ", carts);

  	this.customerCarts = carts;
  }

  getCustomerCarts(){
    return this.customerCarts;
  }
}


// WEBPACK FOOTER //
// ./src/providers/user-cart-provider/user-carts.ts